<template>
    <open-checkout-popup v-if="defaultPaymentMethod === 'null' && salesButtonSeen">
        <limited-spots />
    </open-checkout-popup>
    <limited-spots @click.prevent="scrollToPaymentBlock" v-else />
</template>

<script>
import { fixedTopBarMixin } from '../mixins/fixedTopBarMixin';
import { mapState } from 'vuex';

export default {
    mixins: [fixedTopBarMixin],
    computed: {
        ...mapState(['defaultPaymentMethod', 'salesButtonSeen']),
    },
};
</script>
